export function __nextjs_pure<T>(expr: T): T {
  return expr
}
